import type { MisconceptionDefinition } from '../types'

export const GET_PROCENTEN: MisconceptionDefinition[] = [
  {
    id: 'get.percentage-of-vs-increase',
    label: 'Percentage van vs. toename',
    module: 'Getalbegrip',
    description:
      'Leerling verwart "X% van" met "X% toename" (bijv. 20% van 100 vs. 100 + 20%).',
    typicalFamilies: ['GET-PROC-VAN', 'GET-PROC-TOENAME'],
  },
  {
    id: 'get.btw-procent-van-inclusief',
    label: 'BTW % over inclusief-prijs berekend',
    module: 'Getalbegrip',
    description:
      'Leerling neemt 21% van de prijs inclusief BTW i.p.v. eerst delen door 1,21.',
    typicalFamilies: ['GET-PROC-BTW'],
  },
  {
    id: 'get.btw-trekken-procent',
    label: 'BTW als percentage-aftrek',
    module: 'Getalbegrip',
    description:
      'Leerling trekt simpelweg het percentage van de inclusief-prijs af (-21%) i.p.v. delen door 1,21.',
    typicalFamilies: ['GET-PROC-BTW'],
  },
  {
    id: 'get.btw-excl-als-btw-bedrag',
    label: 'Prijs exclusief verward met BTW-bedrag',
    module: 'Getalbegrip',
    description:
      'Leerling geeft de prijs exclusief BTW als antwoord op de vraag naar het BTW-bedrag (of omgekeerd).',
    typicalFamilies: ['GET-PROC-BTW'],
  },
  {
    id: 'get.btw-percentage-als-bedrag',
    label: 'Percentage als eurobedrag',
    module: 'Getalbegrip',
    description:
      'Leerling telt het percentage (b.v. €21) als bedrag op i.p.v. 21% × prijs.',
    typicalFamilies: ['GET-PROC-BTW'],
  },
  {
    id: 'get.btw-tarief-verwisseld',
    label: 'BTW-tarief verwisseld (9% vs 21%)',
    module: 'Getalbegrip',
    description:
      'Leerling gebruikt het verkeerde BTW-tarief of past 21% toe bij een 9%-product.',
    typicalFamilies: ['GET-PROC-BTW'],
  },
  {
    id: 'get.btw-deeltotaal-als-eind',
    label: 'Subtotaal exclusief als eindbedrag',
    module: 'Getalbegrip',
    description:
      'Leerling geeft het totaal exclusief BTW als eindprijs voor de klant.',
    typicalFamilies: ['GET-PROC-BTW'],
  },
  {
    id: 'get.percentage-divide-confusion',
    label: 'Verkeerd gedeeld bij %-berekening',
    module: 'Getalbegrip',
    description:
      'Leerling deelt door een verkeerd getal (b.v. door 10 i.p.v. 100) bij het toepassen van de 1%- of 10%-methode.',
    typicalFamilies: ['GET-PROC-VAN', 'GET-PROC-BASIS'],
  },
  {
    id: 'get.percentage-swap-method',
    label: 'Tussenstap verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling verwisselt tussenstappen bij de 10%/5%/1%-methode (b.v. 10% + 5% verwisseld).',
    typicalFamilies: ['GET-PROC-VAN', 'GET-PROC-BASIS'],
  },
  {
    id: 'get.percentage-round-error',
    label: 'Afrondfout bij %-berekening',
    module: 'Getalbegrip',
    description:
      'Leerling rondt een tussenresultaat te vroeg of verkeerd af bij %-berekeningen.',
    typicalFamilies: ['GET-PROC-VAN', 'GET-PROC-BASIS', 'GET-PROC-BTW'],
  },
  {
    id: 'get.decimaal-komma-verschuiving',
    label: 'Komma één plek verschoven bij %-omzetting',
    module: 'Getalbegrip',
    description:
      'Leerling schuift de komma één plek te ver/te weinig bij omzetting decimaal ↔ procent (0,5 → 5% i.p.v. 50%).',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.decimaal-is-procent',
    label: 'Decimaal direct als procent gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat een decimaal getal direct een percentage is (0,5 = 0,5%).',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.decimaal-keer-1000',
    label: 'Decimaal × 1000 i.p.v. × 100',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt een decimaal met 1000 i.p.v. 100 bij omzetting naar procent.',
    typicalFamilies: ['GET-PROC-BASIS'],
  },
  {
    id: 'get.aantal-is-procent',
    label: 'Aantal direct als percentage gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling neemt het aantal stukken (b.v. 5) direct als percentage (5%) zonder te relateren aan het totaal.',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-PROC-VAN'],
  },
  {
    id: 'get.totaal-is-procent',
    label: 'Totaal direct als percentage gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling neemt het totaal aantal (b.v. 20) direct als percentage (20%).',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-PROC-VAN'],
  },
  {
    id: 'get.procent-is-aantal',
    label: 'Percentage als aantal stuks gelezen',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat 75% gelijk is aan 75 stuks, zonder rekening te houden met het totaal.',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-PROC-VAN'],
  },
  {
    id: 'get.procent-deel-10',
    label: 'Procent gedeeld door 10 i.p.v. 100',
    module: 'Getalbegrip',
    description:
      'Leerling deelt het percentage door 10 i.p.v. 100 (75% van 100 → 7,5).',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-PROC-VAN'],
  },
  {
    id: 'get.percent-fraction-swap',
    label: 'Percentage-breuk koppeling omgedraaid',
    module: 'Getalbegrip',
    description:
      'Leerling koppelt het verkeerde percentage aan een breuk (75% ↔ ¼) door teller-noemer-verwisseling.',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.percent-fraction-approx',
    label: 'Breuk bij benadering gekozen',
    module: 'Getalbegrip',
    description:
      'Leerling kiest een breuk die alleen ongeveer klopt (b.v. ⅓ voor 30%) zonder exacte koppeling.',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.percent-fraction-close',
    label: 'Dichtbij percentage, verkeerde breuk',
    module: 'Getalbegrip',
    description:
      'Leerling kiest een breuk die qua percentage dichtbij ligt maar niet de exacte koppeling is.',
    typicalFamilies: ['GET-PROC-BASIS', 'GET-VERH-BREUK-PROC-KOPPEL'],
  },
  {
    id: 'get.percent-compound-added',
    label: 'Kortingen/stijgingen opgeteld i.p.v. samengesteld',
    module: 'Getalbegrip',
    description:
      'Leerling telt twee opeenvolgende percentages bij elkaar op (bv. 20% + 10% = 30%) i.p.v. ze stap voor stap toe te passen op de tussenliggende prijs.',
    typicalFamilies: [
      'GET-PROC-SAMENGESTELD',
      'GET-PROC-TOENAME',
      'GET-PROC-AFNAME',
    ],
  },
  {
    id: 'get.percent-second-on-original',
    label: 'Tweede percentage op originele prijs',
    module: 'Getalbegrip',
    description:
      'Leerling past de tweede korting/stijging toe op de oorspronkelijke prijs i.p.v. op de nieuwe (tussenliggende) prijs.',
    typicalFamilies: ['GET-PROC-SAMENGESTELD'],
  },
  {
    id: 'get.percent-step-omitted',
    label: 'Een van de samengestelde stappen overgeslagen',
    module: 'Getalbegrip',
    description:
      'Leerling rekent slechts één van twee opeenvolgende percentage-bewerkingen uit en stopt bij de tussenprijs.',
    typicalFamilies: ['GET-PROC-SAMENGESTELD'],
  },
  {
    id: 'get.percent-increase-decrease-symmetric',
    label: '+x% en −x% beschouwd als gelijk aan beginprijs',
    module: 'Getalbegrip',
    description:
      'Leerling denkt dat +x% gevolgd door −x% (of omgekeerd) uitkomt op de oorspronkelijke prijs — over het hoofd ziend dat de tweede bewerking over een ander bedrag gaat.',
    typicalFamilies: ['GET-PROC-SAMENGESTELD'],
  },
  {
    id: 'get.percent-amount-as-final',
    label: 'Korting/stijgingsbedrag als eindprijs',
    module: 'Getalbegrip',
    description:
      'Leerling geeft het bedrag van de korting of stijging zelf als eindprijs, in plaats van het van de oorspronkelijke prijs af te trekken of erbij op te tellen.',
    typicalFamilies: ['GET-PROC-SAMENGESTELD', 'GET-PROC-KORTING'],
  },
  {
    id: 'get.percentage-of-wrong-base',
    label: 'Percentage van verkeerd basisbedrag',
    module: 'Getalbegrip',
    description:
      'Leerling berekent het percentage over een verkeerd basisbedrag (bv. afgerond getal, andere prijs uit de context) i.p.v. over het juiste bedrag.',
    typicalFamilies: [
      'GET-PROC-VAN',
      'GET-PROC-KORTING',
      'GET-PROC-SAMENGESTELD',
    ],
  },
  {
    id: 'get.procent-terug-deelt-door-procent',
    label: 'Deelt door percentage in plaats van breuk-equivalent',
    module: 'Getalbegrip',
    description:
      'Leerling deelt het deelbedrag door het getal van het percentage zelf (bv. door 20) i.p.v. door 0,20 of door 1/5.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'get.procent-terug-procent-keer',
    label: 'Vermenigvuldigt met percentage als breuk i.p.v. te delen',
    module: 'Getalbegrip',
    description:
      'Leerling rekent deelbedrag × percentage in plaats van deelbedrag ÷ percentage om het origineel te vinden.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'get.procent-terug-stopt-bij-deel',
    label: 'Stopt bij deelbedrag als antwoord',
    module: 'Getalbegrip',
    description:
      'Leerling geeft het deelbedrag (bv. de korting of het percentage-deel) terug als origineel bedrag.',
    typicalFamilies: ['GET-PROC-TERUG', 'GET-PROC-NIEUW'],
  },
  {
    id: 'proc.terug-vermenigvuldigen',
    label: 'Vermenigvuldigt deel met percentage i.p.v. delen',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt het bekende deel met het percentage in plaats van het deel te delen door het percentage.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-optellen',
    label: 'Telt percentage op bij deel',
    module: 'Getalbegrip',
    description:
      'Leerling telt het percentage als getal op bij het bekende deel in plaats van te delen door het percentage.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-deel-keer-percentage',
    label: 'Berekent percentage van het deel i.p.v. het geheel',
    module: 'Getalbegrip',
    description:
      'Leerling berekent percentage van het bekende deel in plaats van terug te rekenen naar het geheel.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-percentage-over-betaalde',
    label: 'Past percentage toe op betaalde prijs i.p.v. origineel',
    module: 'Getalbegrip',
    description:
      'Leerling past het kortingspercentage toe op de al verlaagde prijs in plaats van op de originele prijs.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-korting-aftrekken-van-betaalde',
    label: 'Trekt korting af van al verlaagde prijs',
    module: 'Getalbegrip',
    description:
      'Leerling trekt het kortingsbedrag nogmaals af van de reeds verlaagde prijs in plaats van terug te rekenen.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-percentage-als-bedrag',
    label: 'Behandelt percentage als euro-bedrag',
    module: 'Getalbegrip',
    description:
      'Leerling behandelt het percentage als een geldbedrag en trekt het rechtstreeks af van het deel.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-deel-aftrekken-bij-rest',
    label: 'Trekt deel af i.p.v. terugrekenen naar geheel',
    module: 'Getalbegrip',
    description:
      'Leerling trekt het deel af van een aangenomen totaal in plaats van te terugrekenen via de 1%-methode.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-deel-keer-vast-getal',
    label: 'Vermenigvuldigt deel met willekeurige factor',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt het deel met een willekeurige factor zonder relatie tot het percentage.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.korting-als-vast-bedrag',
    label: 'Kortingspercentage als vast bedrag',
    module: 'Getalbegrip',
    description:
      'Leerling trekt het percentage als euro-bedrag af in plaats van het percentage van de prijs te nemen.',
    typicalFamilies: ['GET-PROC-AFNAME'],
  },
  {
    id: 'proc.afname-korting-als-eindbedrag',
    label: 'Korting als eindbedrag opgevat',
    module: 'Getalbegrip',
    description:
      'Leerling geeft het kortingsbedrag als antwoord in plaats van de prijs na korting.',
    typicalFamilies: ['GET-PROC-AFNAME'],
  },
  {
    id: 'proc.afname-percentage-verwisseld',
    label: 'Percentage en restpercentage verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling verwisselt het kortingspercentage met het restpercentage (bv. 25% korting → 25% van prijs).',
    typicalFamilies: ['GET-PROC-AFNAME'],
  },
  {
    id: 'proc.toename-als-vast-bedrag',
    label: 'Toename als vast bedrag opgevat',
    module: 'Getalbegrip',
    description:
      'Leerling telt het percentage als euro-bedrag op in plaats van het percentage van de prijs te nemen.',
    typicalFamilies: ['GET-PROC-TOENAME'],
  },
  {
    id: 'proc.toename-als-afname',
    label: 'Toename verward met afname',
    module: 'Getalbegrip',
    description:
      'Leerling trekt het percentage af in plaats van op te tellen bij een prijsstijging.',
    typicalFamilies: ['GET-PROC-TOENAME'],
  },
  {
    id: 'proc.toename-factor-fout',
    label: 'Verkeerde factor bij toename',
    module: 'Getalbegrip',
    description:
      'Leerling gebruikt een verkeerde vermenigvuldigingsfactor (bv. 1,10 i.p.v. 1,15) bij prijsstijging.',
    typicalFamilies: ['GET-PROC-TOENAME'],
  },
  {
    id: 'proc.toename-percentage-verwisseld',
    label: 'Percentage en eindpercentage verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling verwisselt het stijgingspercentage met het totale eindpercentage (bv. 15% stijging → 15% van prijs).',
    typicalFamilies: ['GET-PROC-TOENAME'],
  },
  {
    id: 'proc.terug-rest-misrekend',
    label: 'Restpercentage misrekend bij terugrekenen',
    module: 'Getalbegrip',
    description:
      'Leerling berekent het restpercentage (100% − kortingspercentage) verkeerd of past het op de verkeerde manier toe bij terugrekenen naar de originele prijs.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
  {
    id: 'proc.terug-rest-gebruikt',
    label: 'Restpercentage gebruikt i.p.v. korting',
    module: 'Getalbegrip',
    description:
      'Leerling gebruikt het restpercentage in plaats van het kortingspercentage bij terugrekenen, of omgekeerd, waardoor de berekening de verkeerde kant op gaat.',
    typicalFamilies: ['GET-PROC-TERUG'],
  },
]
